(() => {
  const desktopQuery = window.matchMedia('(min-width: 1151px)');
  let closeTimer;
  let suppressFocusOpen = false;

  const items = () => Array.from(document.querySelectorAll('.klampet-dog-chews-menu'));
  const triggerFor = (item) => item.querySelector(':scope > [data-klampet-mega-trigger]');
  const panelFor = (item) => item.querySelector(':scope > [data-klampet-mega-panel]');

  function closeItem(item, restoreFocus = false) {
    const trigger = triggerFor(item);
    item.classList.remove('is-klampet-open', 'is-mobile-open');
    panelFor(item)?.classList.add('is-hidden');
    trigger?.setAttribute('aria-expanded', 'false');
    item.querySelectorAll('.klampet-mega-group').forEach((group) => {
      group.classList.remove('is-group-open');
      group.querySelector(':scope > h5 > [data-klampet-group-trigger]')?.setAttribute('aria-expanded', 'false');
    });
    if (restoreFocus) trigger?.focus();
  }

  function closeAll(except = null) {
    window.clearTimeout(closeTimer);
    items().forEach((item) => {
      if (item !== except) closeItem(item);
    });
  }

  function positionPanel(item) {
    const panel = panelFor(item);
    if (!panel) return;
    const headerBand =
      item.closest('.sticky-header-active, .dt-sc-header-logo-sec, header') ||
      document.querySelector('#header');
    const bottom = Math.max(0, Math.round(headerBand.getBoundingClientRect().bottom));
    panel.style.setProperty('--klampet-mega-top', `${bottom}px`);
  }

  function openDesktop(item) {
    closeAll(item);
    item.classList.remove('is-klampet-dismissed');
    positionPanel(item);
    item.classList.add('is-klampet-open');
    panelFor(item)?.classList.remove('is-hidden');
    triggerFor(item)?.setAttribute('aria-expanded', 'true');
  }

  function toggleMobile(item) {
    const willOpen = !item.classList.contains('is-mobile-open');
    closeAll(item);
    item.classList.toggle('is-mobile-open', willOpen);
    panelFor(item)?.classList.toggle('is-hidden', !willOpen);
    triggerFor(item)?.setAttribute('aria-expanded', String(willOpen));
  }

  function initializeAccessibility(root = document) {
    root.querySelectorAll?.('[data-klampet-mega-trigger], [data-klampet-group-trigger]').forEach((trigger) => {
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('pointerover', (event) => {
    if (!desktopQuery.matches) return;
    const item = event.target.closest('.klampet-dog-chews-menu');
    if (!item || item.contains(event.relatedTarget)) return;
    window.clearTimeout(closeTimer);
    item.classList.remove('is-klampet-dismissed');
    openDesktop(item);
  });

  document.addEventListener('pointerout', (event) => {
    if (!desktopQuery.matches) return;
    const item = event.target.closest('.klampet-dog-chews-menu');
    if (!item || item.contains(event.relatedTarget)) return;
    closeTimer = window.setTimeout(() => {
      item.classList.remove('is-klampet-dismissed');
      closeItem(item);
    }, 140);
  });

  document.addEventListener('focusin', (event) => {
    if (!desktopQuery.matches) return;
    const item = event.target.closest('.klampet-dog-chews-menu');
    if (item && !suppressFocusOpen) openDesktop(item);
    else closeAll();
  });

  document.addEventListener('focusout', (event) => {
    if (!desktopQuery.matches) return;
    const item = event.target.closest('.klampet-dog-chews-menu');
    if (!item || item.contains(event.relatedTarget)) return;
    closeTimer = window.setTimeout(() => {
      if (!item.contains(document.activeElement)) closeItem(item);
    }, 0);
  });

  document.addEventListener('click', (event) => {
    const megaTrigger = event.target.closest('[data-klampet-mega-trigger]');
    if (megaTrigger && !desktopQuery.matches) {
      event.preventDefault();
      toggleMobile(megaTrigger.closest('.klampet-dog-chews-menu'));
      return;
    }

    const groupTrigger = event.target.closest('[data-klampet-group-trigger]');
    if (groupTrigger && !desktopQuery.matches) {
      event.preventDefault();
      const group = groupTrigger.closest('.klampet-mega-group');
      const willOpen = !group.classList.contains('is-group-open');
      group.parentElement.querySelectorAll(':scope > .klampet-mega-group').forEach((sibling) => {
        sibling.classList.remove('is-group-open');
        sibling.querySelector(':scope > h5 > [data-klampet-group-trigger]')?.setAttribute('aria-expanded', 'false');
      });
      group.classList.toggle('is-group-open', willOpen);
      groupTrigger.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    if (!event.target.closest('.klampet-dog-chews-menu')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openItem = items().find((item) =>
      item.classList.contains('is-klampet-open') || item.classList.contains('is-mobile-open')
    );
    if (openItem) {
      event.preventDefault();
      suppressFocusOpen = true;
      openItem.classList.add('is-klampet-dismissed');
      closeItem(openItem, true);
      window.setTimeout(() => {
        suppressFocusOpen = false;
      }, 0);
    }
  });

  window.addEventListener('resize', () => {
    closeAll();
    items().forEach((item) => {
      if (desktopQuery.matches && item.matches(':hover')) openDesktop(item);
    });
  });

  initializeAccessibility();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) initializeAccessibility(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
